import app from 'flarum/forum/app';
import classList from 'flarum/common/utils/classList';
import Component from 'flarum/common/Component';

export default class VisibilitySelector extends Component {
  view() {
    const { isPrivate, onchange, disabled = false } = this.attrs;
    const options = [
      {
        value: true,
        emoji: '🔒',
        label: app.translator.trans('jcswa-discussion-visibility.forum.composer.private_option'),
      },
      {
        value: false,
        emoji: '🌐',
        label: app.translator.trans('jcswa-discussion-visibility.forum.composer.public_option'),
      },
    ];

    return (
      <div className="DiscussionVisibility-selector" role="radiogroup" aria-label={app.translator.trans('jcswa-discussion-visibility.forum.composer.visibility_label')}>
        {options.map((option) => {
          const selected = isPrivate === option.value;

          return (
            <button
              className={classList('DiscussionVisibility-option', { active: selected })}
              type="button"
              role="radio"
              aria-checked={selected ? 'true' : 'false'}
              disabled={disabled}
              onclick={() => onchange(option.value)}
            >
              <span className="DiscussionVisibility-emoji" aria-hidden="true">
                {option.emoji}
              </span>
              <span className="DiscussionVisibility-label">{option.label}</span>
              {selected && <span className="DiscussionVisibility-check" aria-hidden="true">✓</span>}
            </button>
          );
        })}
      </div>
    );
  }
}
